import React, { useEffect } from "react"
import { Grid } from "@mui/material"

import { AppNote } from "@components"
import { useAcrissGroups } from "Pages/User/Settings/AcrissGroupTab/@hooks"
import { acrissGroupData, clearAcrissGroupSignals, isLoadingAcrissGroupData } from "Pages/User/Settings/AcrissGroupTab/@signals"
import AcrissGroupDrawer from "./Drawer"
import AcrissGroupsTable from "./Table"


export default function UserSettingAcrissGroupTab() {
	const { getAcrissGroupData } = useAcrissGroups()

	useEffect(() => {
		getAcrissGroupData()

		return clearAcrissGroupSignals
	}, [])

	const isEmpty = !isLoadingAcrissGroupData.value && !acrissGroupData.value?.length

	return <Grid container spacing={2}>
		{isEmpty && <Grid item xs={12}>
			<AppNote>
				No acriss groups yet. A group joins several acriss codes under one name (for example
				"Compacto" with CCAR and CDAR) so the One Way analyzer can show one column per group
				instead of one per code.
			</AppNote>
		</Grid>}

		{/* The list holds the create button in its toolbar, as every list of the app, so it stays
		    on screen while there are no groups yet */}
		<AcrissGroupsTable />

		<AcrissGroupDrawer />
	</Grid>
}
